import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { WorkOrderDetail } from './WorkOrderDetail';
import { WorkOrderList } from './WorkOrderList';

export const WorkOrder = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={WorkOrderList} />
    <Route path={`${props.match.path}/:id`} component={WorkOrderDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/workOrder/WorkOrder.tsx